// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1ToVL","logo":"style_logo__3jW-h","item":"style_item__X4rXl","bold":"style_bold__1LDkH"};